import MicroApp from '@/components/MicroApp/index.tsx'

export default function createMicroApp(props) {
  return <MicroApp {...props} />
}

export function createProdUrl(appName) {
  return window.location.origin + '/micro/' + appName + '/'
}
